// Generic JSON-LD renderer — every schema component below builds a plain
// object and hands it to this, so there's one place that actually emits the
// <script> tag. Keeps each schema's own file focused on just the data shape.
export default function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
